import styled from 'styled-components/macro'
import { theme } from 'styled-tools'
import { Link } from 'react-router-dom'
import { Button as btn } from 'reactstrap'
import { media } from '../../../ui/rwd'

const CookiesBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.4);
  color: ${theme('white')};
  z-index: 1060;
  padding: 0.8rem;
  padding: calc(0.8rem + env(safe-area-inset-top)) 0.8rem 0.8rem 0.8rem;
`

const ReadMore = styled(Link)`
  text-decoration: underline;
  font-weight: 400;
  cursor: pointer;
  color: ${theme('white')};
  &:hover {
    color: ${theme('gold')};
  }
`

const Text = styled.p`
  margin-bottom: 0;
  font-size: 1rem;
  color: ${theme('white')};
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.6);
`

const Button = styled(btn)`
  &.btn {
    margin-left: auto;
    ${media.md`
         margin-left: 0.4rem;
    `}
  }
`

export { CookiesBoxWrapper, ReadMore, Text, Button }
